import React from 'react';
import { ModalController } from '../../../../components/Modal/ControlledModal';
import { Order, updateOrder } from '../../../../model/order';
import { useChanges, Form } from '../../../../components/Form/Form';
import { handleError } from '../../../../model/notification';
import { Datepicker } from '../../../../components/Form/Datepicker/Datepicker';
import { t } from '../../../../locales/translate';

interface Props {
  controller: ModalController<Order>;
}

export function EditCancelAt({ controller }: Props): JSX.Element {
  const [changes, , model, trackChanges] = useChanges<Order & { userId?: string }>({
    ...controller.model,
    userId: controller.model.user && controller.model.user.id,
  });

  async function handleOnSubmit(): Promise<void> {
    try {
      await updateOrder({
        orderId: model.id,
        cancelAt: changes.cancelAt || null,
      });
      controller.close();
    } catch (e) {
      handleError(e);
    }
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {() => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: !!changes,
        });
        return (
          <>
            <Datepicker position={'top'} required hourpicker label={t.model.order.autoCancelAt} name="cancelAt" />
          </>
        );
      }}
    </Form>
  );
}
